import Basic from '@/layouts/Basic';

const ResetPassword = () => import('@/views/resetPassword');

const router = [
    {
        path: '/reset-password',
        component: Basic,
        children: [
            {
                path: '',
                name: 'resetPassword',
                component: ResetPassword,
            },
        ],
    },
];

export default router;
